/**
 * Open the support form from anywhere.
 *
 * Several pages offered help as a `mailto:` link instead. A `mailto:` assumes
 * the reader has a desktop mail client configured — on a phone, or in a browser
 * where nothing is registered for the scheme, the link does nothing at all, and
 * the visitor is left believing they have no way to reach us. It also loses the
 * message: it never arrives anywhere we can see, so nobody can follow it up, and
 * it leaks the address to every scraper that reads the page.
 *
 * The support form posts to the platform, is rate limited, and copies
 * management, so a message sent from any of these places lands somewhere it can
 * be answered. `HelpButton` is mounted by both layouts and listens for this
 * event, so every page already has a form to open.
 */
export const SUPPORT_EVENT = 'bindle:open-support'

export function openSupport(): void {
  window.dispatchEvent(new CustomEvent(SUPPORT_EVENT))
}
